module.exports = __webpack_public_path__ + "media/images/icons/icon_play-6dd50d1eca0da20772e3195944f02c67.svg";